import { writable } from 'svelte/store';
import { PromptService } from '@/services';
import hooksAreaLoadingStore from './loading-hooks';
const initialState = {
    hooks: [],
    activeIndex: {
        hook: undefined,
        modified: false
    },
    status: 'processing',
    ready: false
};
// Init state
const { subscribe, update } = writable(initialState);
const actions = {
    set: (updatedState) => {
        update(store => ({ ...store, ...updatedState }));
    },
    async getVideoHooks(videoId) {
        if (!videoId) {
            return;
        }
        hooksAreaLoadingStore.set(true);
        await new PromptService()
            .getVideoHooks(videoId)
            .then(response => {
            if (response.length > 0) {
                update(fs => {
                    return {
                        ...fs,
                        hooks: response,
                        ready: true
                    };
                });
                hooksAreaLoadingStore.set(false);
            }
            else {
                setTimeout(() => {
                    hooksAreaLoadingStore.set(true);
                    this.getVideoHooks(videoId);
                }, 2000);
            }
        })
            .catch(error => {
            setTimeout(() => {
                hooksAreaLoadingStore.set(true);
                this.getVideoHooks(videoId);
            }, 2000);
        });
    },
    async getPromptStatus(videoId) {
        if (!videoId) {
            return;
        }
        await new PromptService().getPromptStatus(videoId).then(response => {
            if (response === 'processing') {
                setTimeout(() => {
                    hooksAreaLoadingStore.set(true);
                    this.getPromptStatus(videoId);
                }, 10000);
            }
            if (response === 'completed') {
                this.getVideoHooks(videoId);
            }
            update(fs => {
                return {
                    ...fs,
                    status: response
                };
            });
        });
    },
    async regenerateAISC(videoId, llm) {
        if (!videoId) {
            return;
        }
        await new PromptService().regenerateAISC(videoId, llm).then(response => {
            update(fs => {
                return {
                    ...fs,
                    hooks: [],
                    status: response
                };
            });
            this.getPromptStatus(videoId);
        });
    },
    async setActiveIndex(index) {
        update(fs => {
            return {
                ...fs,
                activeIndex: index
            };
        });
    },
    async setStatus(state) {
        update(fs => {
            return {
                ...fs,
                status: state
            };
        });
    },
    resetState() {
        update(fs => ({
            ...fs,
            hooks: [],
            activeIndex: {
                hook: undefined,
                modified: false
            },
            ready: false
        }));
    }
};
const prompt = {
    ...actions,
    subscribe
};
export default prompt;
